/* import __COLOCATED_TEMPLATE__ from './testing.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import type Action from 'embercom/models/workflow-connector/action';
import type Store from '@ember-data/store';
import type IntlService from 'ember-intl/services/intl';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

interface Args {
  workflowAction: Action;
  templatedParameters: any;
  clearTemplatedParameter: () => void;
  nextSection: (sectionId: string) => void;
  saveTemplatedParameter: (requestParameter: any, requestValue: any) => void;
}
export default class Testing extends Component<Args> {
  @service declare intl: IntlService;
  @service declare store: Store;
  @service declare appService: any;
  @service declare notificationsService: any;

  get isMockConfigurationSelected() {
    return this.args.workflowAction?.configurationResponseType === 'mock_response_type';
  }

  get app() {
    return this.appService.app;
  }

  @action
  setResponseTypeToTest() {
    this.args.workflowAction.configurationResponseType = 'test_response_type';
    this.args.workflowAction.codeBlockExecutionTestResult = null;
  }

  @action
  setResponseTypeToMock() {
    this.args.workflowAction.configurationResponseType = 'mock_response_type';
    this.args.workflowAction.codeBlockExecutionTestResult = null;
  }

  @action
  previousSection() {
    this.args.nextSection('request_section');
  }

  @action
  nextSection() {
    if (this.app.canUseConsolidatedActions) {
      this.args.nextSection('data_access_section');
      return;
    }

    this.args.nextSection('response_section');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::Builder::Body::Sections::Testing': typeof Testing;
    'workflow-connector/builder/body/sections/testing': typeof Testing;
  }
}
